module.exports = __webpack_public_path__ + "static/banner-195abd3b272045cadae2cacda11d94cc.png";